import { Component, effect, input, output, signal } from '@angular/core';
import { form, FormField, required } from '@angular/forms/signals';
import { AttendancePrescriptionCandidateObject } from '@libs/types/src/services/object-type/attendance/attendance-prescription-candidate.object';
import { dateFromMinutes } from '@libs/shared/utils/date.utils';
import { DateInputComponent } from '../../../kit/input/date-input-v2/date-input.component';
import { TextInputComponent } from '../../../kit/input/text-input-v2/text-input.component';
import { ButtonComponent } from '../../../kit/button/button.component';
import { AvatarComponent } from '../../../../modules/shared/components/kit/avatar/avatar.component';
import { FormatPersonPipe } from '../../../../modules/shared/pipes/format-person.pipe';
import { CardComponent } from '../../../kit/card/card.component';
import {
    AttendanceCandidateConfirmEvent,
    AttendanceCandidateFormModel,
} from '../attendance-candidates-dialog/attendance-candidates-dialog.types';

@Component({
    selector: 'app-attendance-candidate-card',
    templateUrl: './attendance-candidate-card.component.html',
    styleUrl: './attendance-candidate-card.component.scss',
    imports: [
        FormField,
        DateInputComponent,
        TextInputComponent,
        ButtonComponent,
        AvatarComponent,
        FormatPersonPipe,
        CardComponent,
    ],
})
export class AttendanceCandidateCardComponent {

    public candidate = input.required<AttendancePrescriptionCandidateObject>();
    public confirmAttendance = output<AttendanceCandidateConfirmEvent>();
    public checkout = output<AttendancePrescriptionCandidateObject>();

    protected readonly formData = signal<AttendanceCandidateFormModel>({
        timeFrom: null,
        timeTo: null,
        note: null,
    });

    protected readonly formDef = form(this.formData, schema => {
        required(schema.timeFrom);
        required(schema.timeTo);
    });

    constructor() {
        effect(() => {
            const candidate = this.candidate();
            this.formData.set({
                timeFrom: dateFromMinutes(candidate.timeFrom),
                timeTo: dateFromMinutes(candidate.timeTo),
                note: candidate.note,
            });
        });
    }

    protected confirm(): void {
        const value = this.formData();
        if (this.formDef().invalid() || !value.timeFrom || !value.timeTo) return;

        this.confirmAttendance.emit({
            candidate: this.candidate(),
            timeFrom: value.timeFrom,
            timeTo: value.timeTo,
            note: value.note,
        });
    }

}
